import { HeadCell } from '../../../models/TableProps';
import { QuotationSummaryProdTableItem } from '../../../models/quotations/Quotation';

export const QuotationEditProductsTableHead: HeadCell<QuotationSummaryProdTableItem>[] =
    [
        {
            id: 'name',
            numeric: false,
            disablePadding: false,
            label: 'NAME',
            sortable: true,
        },
        {
            id: 'quantity',
            numeric: true,
            disablePadding: false,
            label: 'QUANTITY',
            sortable: true,
        },
        {
            id: 'net_unit_price',
            numeric: true,
            disablePadding: false,
            label: 'NET_UNIT_PRICE',
            sortable: true,
        },
        {
            id: 'price_margin',
            numeric: true,
            disablePadding: false,
            label: 'SUMMARIES_PRICE_MARGIN',
            sortable: true,
        },
        {
            id: 'net_price',
            numeric: true,
            disablePadding: false,
            label: 'NET_PRICE',
            sortable: true,
        },

        {
            id: 'tax',
            numeric: true,
            disablePadding: false,
            label: 'TAX',
            sortable: true,
        },
        {
            id: 'gross_price',
            numeric: true,
            disablePadding: false,
            label: 'GROSS_AMOUNT',
            sortable: true,
        },
    ];

export const QuotationSummariesTableHead: HeadCell<QuotationSummaryProdTableItem>[] =
    [
        {
            id: 'name',
            numeric: false,
            disablePadding: false,
            label: '',
            sortable: true,
        },
        {
            id: 'net_price',
            numeric: true,
            disablePadding: false,
            label: 'SUMMARIES_NET_PRICE',
            sortable: true,
        },
        {
            id: 'tax',
            numeric: true,
            disablePadding: false,
            label: 'TAX',
            sortable: true,
        },
        {
            id: 'gross_price',
            numeric: true,
            disablePadding: false,
            label: 'SUMMARIES_GROSS_AMOUNT',
            sortable: true,
        },
    ];
